import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { Notification } from './components/notification';
import { GlobalProvider } from './context/global-context';
import { AppThemeProvider } from './context/theme-context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AppThemeProvider>
    <GlobalProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
          <Notification />
        </BrowserRouter>
      </Provider>
    </GlobalProvider>
  </AppThemeProvider>
);